import { Radio, Select } from 'antd'
import { useIsMobile } from '../../hooks/useMediaQuery'
import { IconTextContainer } from '../../components'
import { useMemo } from 'react'

const { Option } = Select

export type TabItem = {
  key: string
  icon: JSX.Element
  label: string
  visible?: boolean
}

interface ResponsiveTabsProps {
  tabs: TabItem[]
  selectedTab: string
  onTabChange: (tab: string) => void
}

const ResponsiveTabs = ({
  tabs,
  selectedTab,
  onTabChange,
}: ResponsiveTabsProps) => {
  const isMobile = useIsMobile()

  const visibleTabs = useMemo(
    () => tabs.filter((tab) => tab.visible !== false),
    [tabs]
  )

  if (isMobile) {
    return (
      <Select
        value={selectedTab}
        onChange={(value) => onTabChange(value)}
        style={{ width: '100%' }}
      >
        {visibleTabs.map(({ key, icon, label }) => (
          <Option key={key} value={key}>
            <IconTextContainer>
              {icon}
              {label}
            </IconTextContainer>
          </Option>
        ))}
      </Select>
    )
  }

  return (
    <Radio.Group value={selectedTab} buttonStyle="solid">
      {visibleTabs.map(({ key, icon, label }) => (
        <Radio.Button key={key} value={key} onClick={() => onTabChange(key)}>
          <IconTextContainer>
            {icon}
            {label}
          </IconTextContainer>
        </Radio.Button>
      ))}
    </Radio.Group>
  )
}
export default ResponsiveTabs
